import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { Widget } from './Widget';
const DATA = [{
  name: 'Consegnate',
  value: 2840,
  color: '#D4FF3A'
}, {
  name: 'In transito',
  value: 510,
  color: '#525252'
}, {
  name: 'Da firmare',
  value: 290,
  color: '#FAFAFA'
}, {
  name: 'In ritardo',
  value: 140,
  color: '#F5A524'
}, {
  name: 'Fallite',
  value: 62,
  color: '#EF4444'
}];
const TOTAL = DATA.reduce((s, d) => s + d.value, 0);
type Props = {
  onViewDetail?: () => void;
};
export function StatusDonut({
  onViewDetail
}: Props = {}) {
  return <Widget title="Distribuzione stato" badge={<span className="text-[10px] font-mono text-[#6B6B6B]" data-id="element-4047">
          {TOTAL.toLocaleString('it-IT')} sped.
        </span>} footerCta={{
    label: 'Filtra per stato',
    onClick: onViewDetail
  }} data-id="element-4046">
      <div className="h-[160px] w-full relative" data-id="element-4048">
        <ResponsiveContainer width="100%" height="100%" data-id="element-4049">
          <PieChart data-id="element-4050">
            <Pie data={DATA} dataKey="value" innerRadius={50} outerRadius={72} paddingAngle={2} stroke="none" isAnimationActive={false} data-id="element-4051">
              {DATA.map(d => <Cell key={d.name} fill={d.color} data-id="element-4052" />)}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-4053">
          <div className="text-[10px] text-[#6B6B6B] uppercase tracking-wide" data-id="element-4054">
            Consegna
          </div>
          <div className="text-2xl font-semibold text-[#D4FF3A] font-heading" data-id="element-4055">
            96.4%
          </div>
        </div>
      </div>

      <div className="mt-4 space-y-1.5" data-id="element-4056">
        {DATA.map(d => {
        const pct = (d.value / TOTAL * 100).toFixed(1);
        return <div key={d.name} className="flex items-center justify-between text-xs" data-id="element-4057">
              <div className="flex items-center gap-2" data-id="element-4058">
                <span className="h-1.5 w-1.5 rounded-full" style={{
              background: d.color
            }} data-id="element-4059" />
                <span className="text-[#9A9A9A]" data-id="element-4060">{d.name}</span>
              </div>
              <span className="text-[#6B6B6B] font-mono" data-id="element-4061">{pct}%</span>
            </div>;
      })}
      </div>
    </Widget>;
}